import { EcommercePlatforms } from '@/types/platform';
import type { BadgeProps } from '@chakra-ui/react';
import { Badge, Image, Text } from '@chakra-ui/react';
import React from 'react';
import shopifyLogo from '@/assets/icons/platforms/shopify.svg';

// Define known platforms and their logo paths
// IMPORTANT: Add actual logo files to the specified paths
const platformLogos: Record<string, { path: string; name: string }> = {
  [EcommercePlatforms.SHOPIFY]: {
    path: shopifyLogo,
    name: 'Shopify',
  },
  [EcommercePlatforms.WOOCOMMERCE]: {
    path: '/src/assets/icons/platforms/woocommerce.svg',
    name: 'WooCommerce',
  },
};

interface EcommercePlatformBadgeProps extends BadgeProps {
  platform: EcommercePlatforms;
  orderNumber?: string;
  showText?: boolean;
}

const EcommercePlatformBadge: React.FC<EcommercePlatformBadgeProps> = ({
  platform,
  orderNumber,
  ...props
}) => {
  const platformInfo = platformLogos[platform] || {
    path: '',
    name: platform || 'Unknown',
  };

  return (
    <Badge
      colorPalette="gray"
      size="md"
      display="inline-flex"
      alignItems="center"
      gap={1}
      {...props}
    >
      {platformInfo.path && (
        <Image src={platformInfo.path} alt={`${platformInfo.name} logo`} boxSize={4} />
      )}

      {orderNumber && (
        <Text fontSize="xs" fontWeight="medium">
          #{orderNumber}
        </Text>
      )}
    </Badge>
  );
};

export default EcommercePlatformBadge;
